class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._onDocMouseMove = this.onDocMouseMove.bind(this);
    this.addEventListener('mouseenter', this.openOnHover.bind(this));
  }

  openOnHover() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    if (!this.mainDetailsToggle.open) {
      this.mainDetailsToggle.setAttribute('open', '');
    }
  }

  startMouseTracking() {
    document.removeEventListener('mousemove', this._onDocMouseMove);
    document.addEventListener('mousemove', this._onDocMouseMove);
  }

  stopMouseTracking() {
    document.removeEventListener('mousemove', this._onDocMouseMove);
  }

  onDocMouseMove(e) {
    if (!this.mainDetailsToggle.open) {
      this.stopMouseTracking();
      return;
    }

    const threshold = 15;

    const menuRect = this.getBoundingClientRect();
    if (
      e.clientX >= menuRect.left - threshold &&
      e.clientX <= menuRect.right + threshold &&
      e.clientY >= menuRect.top - threshold &&
      e.clientY <= menuRect.bottom + threshold
    ) return;

    const content = this.mainDetailsToggle.querySelector('.mega-menu__content, .header__submenu');
    if (content) {
      const contentRect = content.getBoundingClientRect();
      if (
        e.clientX >= contentRect.left - threshold &&
        e.clientX <= contentRect.right + threshold &&
        e.clientY >= contentRect.top - threshold &&
        e.clientY <= contentRect.bottom + threshold
      ) return;
    }

    this.stopMouseTracking();
    this.close();
  }

  close() {
    this.stopMouseTracking();
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.startMouseTracking();
    } else {
      this.stopMouseTracking();
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
